import Svg, { Path } from 'react-native-svg'

const Voice = ({ color = '#0F3CC9', width = 16, height = 16 }: any) => {
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <Path
        fill={color}
        d="M8 1.333A.667.667 0 0 0 7.333 2v12a.667.667 0 1 0 1.334 0V2A.667.667 0 0 0 8 1.333ZM2.667 6A.667.667 0 0 0 2 6.666v2.667a.667.667 0 0 0 1.333 0V6.666A.667.667 0 0 0 2.667 6Zm2.666-2a.667.667 0 0 0-.666.666v6.667a.667.667 0 1 0 1.333 0V4.666A.667.667 0 0 0 5.333 4Zm8 2a.667.667 0 0 0-.666.666v2.667a.667.667 0 1 0 1.333 0V6.666A.666.666 0 0 0 13.333 6Zm-2.666-2a.667.667 0 0 0-.667.666v6.667a.666.666 0 1 0 1.333 0V4.666A.667.667 0 0 0 10.667 4Z"
      />
    </Svg>
  )
}

export default Voice
